/* eslint-disable no-unused-vars */
// noinspection JSUnusedGlobalSymbols
export enum ProjectOrganizationRelationType {
  Initiator = 'Initiator',
  Supporters = 'Supporters',
}
